var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard8({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 388,
    height: 334,
    viewBox: "0 0 388 334",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 388,
    height: 334,
    rx: 24,
    fill: "#F4FFF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M229.679 147.715C234.268 156.013 235.707 165.689 233.731 174.964C231.755 184.239 226.496 192.488 218.923 198.195C211.349 203.901 201.97 206.682 192.51 206.024C183.05 205.367 174.145 201.316 167.434 194.617C160.722 187.918 156.655 179.021 155.981 169.562C155.306 160.103 158.069 150.719 163.762 143.135C169.455 135.551 177.695 130.277 186.966 128.284C196.237 126.291 205.915 127.712 214.222 132.286",
    stroke: "#627A62",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M216.577 154.144C219.617 159.642 220.57 166.052 219.261 172.195C217.952 178.339 214.468 183.804 209.451 187.584C204.434 191.364 198.221 193.206 191.955 192.771C185.688 192.335 179.789 189.652 175.343 185.214C170.897 180.776 168.203 174.882 167.756 168.617C167.31 162.351 169.14 156.134 172.911 151.11C176.682 146.087 182.141 142.593 188.282 141.273C194.423 139.953 200.835 140.894 206.338 143.924",
    stroke: "#627A62",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M206.334 159.479C207.911 162.33 208.406 165.655 207.727 168.842C207.048 172.029 205.241 174.864 202.638 176.825C200.036 178.786 196.813 179.741 193.562 179.515C190.312 179.289 187.252 177.897 184.946 175.595C182.64 173.293 181.242 170.236 181.01 166.986C180.779 163.736 181.728 160.511 183.684 157.905C185.64 155.299 188.472 153.487 191.657 152.802C194.843 152.117 198.169 152.606 201.023 154.177",
    stroke: "#627A62",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M194.5 166.024L213.69 147.571M213.69 147.571L212.235 140.295C212.222 140.23 212.243 140.162 212.29 140.115L222.29 130.115C222.402 130.003 222.592 130.059 222.627 130.213L223.996 136.376C224.013 136.452 224.072 136.511 224.148 136.528L230.311 137.897C230.465 137.931 230.521 138.122 230.409 138.234L221.13 147.513C221.093 147.55 221.042 147.571 220.989 147.571H213.69Z",
    stroke: "#627A62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard8);
export default __webpack_public_path__ + "static/media/Card8.dfa65d6def9cd793809e1a46d8f9754f.svg";
export { ForwardRef as ReactComponent };